import { KeywordDTO } from 'src/common/models/keyword';

export const prepareKeywordsString = (keywords?: KeywordDTO[]) =>
  keywords ? keywords.map((keyword) => keyword.value).join(', ') : undefined;
